import Link from './Link';

export default Link;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Link/index.ts